import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { VigboWhatsNewProps } from 'reactApp/ui/VigboWhatsNew/VigboWhatsNew';

export const renderVigboWhatsNew = ({ onClose, ...data }: VigboWhatsNewProps) =>
    openPopupHelper({ popupName: popupNames.VIGBO_WHATS_NEW, data, onClose });

export const closeVigboWhatsNew = () => closePopupHelper(popupNames.VIGBO_WHATS_NEW);
